import { IDynamicReferencedThing } from '~/interfaces/dynamicFieldsInterfaces';

export function buildVarTag(data: IDynamicReferencedThing): string {
  const label = data.label;
  const additionalClasses = data.additionalClasses || '';

  delete data.label;
  delete data.additionalClasses;
  const refData = JSON.stringify(data);

  return `<var contenteditable="false" class="pill fr-deletable ${ additionalClasses }" data-dynamic='${ refData }'>${ label }</var>`
}